/**
 * Canonical web origin for this app, read from the environment.
 * In preview/production: sourced from the Infisical secret EXPO_PUBLIC_APP_URL (required).
 * In development: falls back to http://localhost:8083 when EXPO_PUBLIC_APP_URL is unset.
 */
export const APP_URL = (() => {
  const rawEnvUrl = process.env.EXPO_PUBLIC_APP_URL as string | undefined;
  const isProd = process.env.NODE_ENV === "production";

  if (rawEnvUrl && rawEnvUrl.trim().length > 0) {
    return rawEnvUrl.trim();
  }

  if (isProd) {
    throw new Error(
      "EXPO_PUBLIC_APP_URL is required in production but is missing or empty. Set it via Infisical.",
    );
  }

  // In non-production environments, fall back to localhost and log a warning.
  // eslint-disable-next-line no-console
  console.warn(
    "EXPO_PUBLIC_APP_URL is not set. Falling back to http://localhost:8083. Set EXPO_PUBLIC_APP_URL via Infisical for preview/production builds.",
  );

  return "http://localhost:8083";
})();

export const APP_STORE_URL = "https://apps.apple.com/app/id000000000";
export const PLAY_STORE_BASE_URL =
  "https://play.google.com/store/apps/details?id=com.aladdinmiles.chinesevendor";

/**
 * Returns the App Store / Play Store URL for downloading the app.
 * For Android a `referrer` containing the invite token is appended so the app
 * can read it on first launch via the Play Install Referrer API as a fallback.
 */
export function getStoreUrl(platform: "ios" | "android", token?: string): string {
  if (platform === "android") {
    const referrer = token ? `&referrer=${encodeURIComponent(`invite_token=${token}`)}` : "";
    return `${PLAY_STORE_BASE_URL}${referrer}`;
  }
  return APP_STORE_URL;
}
